var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "deliverable-listing" },
    [
      _c(
        "b-modal",
        {
          staticClass: "modal-edit-deliverable",
          attrs: {
            size: "xl",
            "hide-footer": "",
            id: "editDeliverableModal",
            title: ""
          },
          on: { hide: _vm.editDeliverableModalHidden }
        },
        [
          _c("EditModal", {
            ref: "refEditModal",
            attrs: {
              allContacts: _vm.allContacts,
              namespace: _vm.namespace,
              tabIndex: _vm.tabIndex
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "deleteDeliverableTemplateConfirmModal",
            type: "warn",
            title: "Confirm Deletion",
            "ok-title": "Yes, Delete"
          },
          on: {
            ok: _vm.onConfirmRemoveDeliverableTemplate,
            cancel: _vm.onCancelRemoveDeliverableTemplate
          }
        },
        [
          _c("p", [
            _vm._v("Are you sure you want to delete "),
            _c("strong", [
              _vm._v(_vm._s(_vm.showRemoveDeliverableTemplateTitle))
            ]),
            _vm._v(" deliverable template?")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "deliverable-header" },
        [
          _c("HeaderIcon", {
            attrs: {
              totalDeliverableCount: this.allDeliverableTemplatesPaginationData
                .total
                ? this.allDeliverableTemplatesPaginationData.total
                : 0,
              totalOutletCount: this.outletCount ? this.outletCount : 0,
              namespace: _vm.namespace
            }
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass:
                "d-inline-block float-right pt-15 mr-3 expand-all-area"
            },
            [
              _vm.$router.currentRoute.name != "globalSearch" &&
              _vm.$router.currentRoute.name != "calendar"
                ? _c(
                    "div",
                    {
                      staticClass: "ml-2 expand-grp cursor-pointer",
                      on: {
                        click: function($event) {
                          return _vm.toggleStatusView(!_vm.expandAll)
                        }
                      }
                    },
                    [
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              modifiers: { hover: true }
                            }
                          ],
                          staticClass: "header-filter-btns expand-ctrls",
                          class: { "none-active-btn": _vm.expandAll },
                          attrs: { variant: "theme", title: "Expand" }
                        },
                        [
                          _c("span", { staticClass: "text" }, [
                            _vm._v("Expand All ")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "icon" }, [
                            _c("i", {
                              staticClass: "fas text-primary fa-expand fa-fw"
                            })
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              modifiers: { hover: true }
                            }
                          ],
                          staticClass: "header-filter-btns expand-ctrls",
                          class: { "none-active-btn": !_vm.expandAll },
                          attrs: { variant: "theme", title: "Collapse" }
                        },
                        [
                          _c("span", { staticClass: "text" }, [
                            _vm._v("Collapse All")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "icon" }, [
                            _c("i", {
                              staticClass: "fas text-primary fa-compress fa-fw"
                            })
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.deliverableTemplatesArray, function(
        deliverableTemplate,
        index
      ) {
        return index != "totalOutlets"
          ? _c(
              "div",
              {
                key: "deliverableTemplate" + index,
                staticClass: "deliverable-block",
                class:
                  !_vm.userAbilities.editMediaCall ||
                  (deliverableTemplate &&
                    deliverableTemplate.permissions &&
                    deliverableTemplate.permissions.viewOnly)
                    ? "read-only"
                    : ""
              },
              [
                _c(
                  "div",
                  { staticClass: "delv-block-resp parent-project-on-hold" },
                  [
                    _c("div", { staticClass: "d-flex flex-row dbox-wrapper" }, [
                      _c(
                        "div",
                        { staticClass: "dbox-left-side dleft-inner-wrap" },
                        [
                          _vm.isSocialMedia(deliverableTemplate)
                            ? _c("div", { staticClass: "top-row" }, [
                                _c("div", { staticClass: "data-items" }, [
                                  _c("span", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(deliverableTemplate.title) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "data-items deliverable-project"
                                  },
                                  [
                                    false
                                      ? _c("DeliverableProjects", {
                                          attrs: {
                                            deliverable: deliverableTemplate,
                                            namespace: _vm.namespace
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\tNO PROJECT\n\t\t\t\t\t\t"
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm._m(0, true),
                                _vm._v(" "),
                                _vm._m(1, true)
                              ])
                            : _c(
                                "div",
                                { staticClass: "top-row" },
                                [
                                  _c("div", { staticClass: "data-items" }, [
                                    _c("span", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(deliverableTemplate.title) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "data-items hide-mobile" },
                                      [
                                        false
                                          ? _c("DeliverableProjects", {
                                              attrs: {
                                                deliverable: deliverableTemplate,
                                                namespace: _vm.namespace
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\tNO PROJECT\n\t\t\t\t\t\t\t"
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.hasPriorityField(deliverableTemplate)
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "data-items hide-mobile"
                                          },
                                          [
                                            _c("span", {}, [
                                              _vm._v("PRIORITY: ")
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-tooltip",
                                                    rawName:
                                                      "v-b-tooltip.hover",
                                                    modifiers: { hover: true }
                                                  }
                                                ],
                                                staticClass: "listing-priority",
                                                class:
                                                  "listing-priority-del-" +
                                                  deliverableTemplate.id,
                                                attrs: { title: "Priority" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.setPriority(
                                                      _vm.deliverable,
                                                      false
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("vue-star-rate", {
                                                  key:
                                                    "del-rating-" +
                                                    Math.random() +
                                                    deliverableTemplate.id,
                                                  attrs: {
                                                    rateRange: deliverableTemplate.priority
                                                      ? Number(
                                                          deliverableTemplate.priority
                                                        )
                                                      : 0,
                                                    maxIcon: 5,
                                                    iconHeight: 17,
                                                    iconWidth: 17,
                                                    hasCounter: false,
                                                    iconColor: "#ffffff",
                                                    iconColorHover: "#ffffff",
                                                    iconShape: "circle"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.showAltStartEndDate(deliverableTemplate)
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "data-items hide-mobile"
                                            },
                                            [
                                              _c("span", {}, [
                                                _vm._v("START DATE:")
                                              ]),
                                              _vm._v(" "),
                                              _vm.calculateStartDate(
                                                deliverableTemplate
                                              )
                                                ? [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm._f("moment")(
                                                            _vm.calculateStartDate(
                                                              deliverableTemplate
                                                            ),
                                                            "DD MMM, YYYY"
                                                          )
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                : [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\tNo Date\n\t\t\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "data-items hide-mobile"
                                            },
                                            [
                                              _c("span", {}, [
                                                _vm._v("END DATE:")
                                              ]),
                                              _vm._v(" "),
                                              _vm.calculateEndDate(
                                                deliverableTemplate
                                              )
                                                ? [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm._f("moment")(
                                                            _vm.calculateEndDate(
                                                              deliverableTemplate
                                                            ),
                                                            "DD MMM, YYYY"
                                                          )
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                : [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\tNo Date\n\t\t\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                            ],
                                            2
                                          )
                                        ]
                                      : [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "data-items hide-mobile"
                                            },
                                            [
                                              _c("span", {}, [
                                                _vm._v("STARTED:")
                                              ]),
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm._f("moment")(
                                                      deliverableTemplate.created_at,
                                                      "DD MMM, YYYY @ H:mm"
                                                    )
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          deliverableTemplate.all_completed
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "data-items hide-mobile"
                                                },
                                                [
                                                  _c("span", {}, [
                                                    _vm._v("COMPLETED:")
                                                  ]),
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm._f("moment")(
                                                          deliverableTemplate.completed_at,
                                                          "DD MMM, YYYY @ H:mm"
                                                        )
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "data-items hide-mobile"
                                                },
                                                [
                                                  _c("span", {}, [
                                                    _vm._v("LAST MODIFIED:")
                                                  ]),
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm._f("moment")(
                                                          deliverableTemplate.updated_at,
                                                          "DD MMM, YYYY @ H:mm"
                                                        )
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                        ]
                                  ]
                                ],
                                2
                              ),
                          _vm._v(" "),
                          _c("DeliverableTypeIcon", {
                            attrs: {
                              deliverableTypeId: deliverableTemplate.id,
                              deliverableProject: deliverableTemplate.project_id
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "row mobile-deli-info" },
                            [
                              _vm.hasPriorityField(deliverableTemplate)
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "data-items deliverable-priority"
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "text-primary" },
                                        [_vm._v("PRIORITY: ")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.hover",
                                              modifiers: { hover: true }
                                            }
                                          ],
                                          staticClass: "listing-priority",
                                          class:
                                            "listing-priority-del-" +
                                            deliverableTemplate.id,
                                          attrs: { title: "Priority" },
                                          on: {
                                            click: function($event) {
                                              return _vm.setPriority(
                                                _vm.deliverable,
                                                true
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("vue-star-rate", {
                                            key:
                                              "del-rating-" +
                                              Math.random() +
                                              deliverableTemplate.id,
                                            attrs: {
                                              rateRange: deliverableTemplate.priority
                                                ? Number(
                                                    deliverableTemplate.priority
                                                  )
                                                : 0,
                                              maxIcon: 5,
                                              iconHeight: 17,
                                              iconWidth: 17,
                                              hasCounter: false,
                                              iconColor: "var(--wf-primary)",
                                              iconColorHover:
                                                "var(--wf-primary)",
                                              iconShape: "circle"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showAltStartEndDate(deliverableTemplate)
                                ? [
                                    _vm._l(
                                      _vm._.filter(
                                        deliverableTemplate.customFields,
                                        { field_key: "start_date" }
                                      ),
                                      function(field, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass:
                                              "data-items deliverable-start"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text-primary" },
                                              [_vm._v("START DATE:")]
                                            ),
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm._f("moment")(
                                                    field.value,
                                                    "DD MMM, YYYY"
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      }
                                    ),
                                    _vm._v(" "),
                                    _vm._.filter(
                                      deliverableTemplate.customFields,
                                      { field_key: "start_date" }
                                    ).length == 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "data-items deliverable-start"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text-primary" },
                                              [_vm._v("START DATE:")]
                                            ),
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\tNo Date\n\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "data-items deliverable-end"
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "text-primary" },
                                          [_vm._v("END DATE:")]
                                        ),
                                        _vm._v(" "),
                                        _vm.calculateEndDate(
                                          deliverableTemplate
                                        )
                                          ? [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm._f("moment")(
                                                      _vm.calculateEndDate(
                                                        deliverableTemplate
                                                      ),
                                                      "DD MMM, YYYY"
                                                    )
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t"
                                              )
                                            ]
                                          : [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\tNo Date\n\t\t\t\t\t\t\t\t"
                                              )
                                            ]
                                      ],
                                      2
                                    )
                                  ]
                                : [
                                    _c("div", { staticClass: "data-items" }, [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-primary deliverable-start"
                                        },
                                        [_vm._v("STARTED:")]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm._f("moment")(
                                              deliverableTemplate.created_at,
                                              "DD MMM, YYYY @ H:mm"
                                            )
                                          ) +
                                          "\n\t\t\t\t\t\t\t"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    deliverableTemplate.all_completed
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "data-items deliverable-completed"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text-primary" },
                                              [_vm._v("COMPLETED:")]
                                            ),
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm._f("moment")(
                                                    deliverableTemplate.completed_at,
                                                    "DD MMM, YYYY @ H:mm"
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass:
                                              "data-items deliverable-last-mod"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text-primary" },
                                              [_vm._v("LAST MODIFIED:")]
                                            ),
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm._f("moment")(
                                                    deliverableTemplate.updated_at,
                                                    "DD MMM, YYYY @ H:mm"
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                  ],
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "data-items deliverable-project"
                                },
                                [
                                  _c("DeliverableProjects", {
                                    attrs: {
                                      deliverable: deliverableTemplate,
                                      namespace: _vm.namespace
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "row listing-row" }, [
                            _c(
                              "div",
                              {
                                class:
                                  " " +
                                  (deliverableTemplate.total_unread_messages_in_conversation >
                                  0
                                    ? "col-md-7"
                                    : "col-md-8 titles ") +
                                  " breakpoint__fix " +
                                  (_vm.isSocialMedia(deliverableTemplate)
                                    ? "social-titles"
                                    : ""),
                                style: _vm.infoColStyle(deliverableTemplate)
                              },
                              [
                                _vm.showDepartment(deliverableTemplate)
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "inside-list department--wrap--new"
                                      },
                                      [
                                        _c("DeliverableDepartments", {
                                          attrs: {
                                            deliverable: deliverableTemplate,
                                            namespace: _vm.namespace
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    class:
                                      "deliverable-title edit-d-title " +
                                      (_vm.showDepartment(deliverableTemplate)
                                        ? ""
                                        : "no-depart"),
                                    on: {
                                      click: function($event) {
                                        return _vm.showModalFn(
                                          deliverableTemplate,
                                          false
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          deliverableTemplate.default_title
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "mobile-task-expand-button-area"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "mobile-task-exp-btn" },
                                      [
                                        _c("CollapseTaskBtn", {
                                          attrs: {
                                            deliverable: deliverableTemplate,
                                            index: index,
                                            expandAll: _vm.expandAll,
                                            namespace: _vm.namespace
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.userCanEditDeliverable() &&
                                deliverableTemplate.can_delete
                                  ? _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            modifiers: { hover: true }
                                          },
                                          {
                                            name: "click-outside",
                                            rawName: "v-click-outside",
                                            value: _vm.deleteDeliverableTemplateClickOutside(
                                              deliverableTemplate.id
                                            ),
                                            expression:
                                              "deleteDeliverableTemplateClickOutside(deliverableTemplate.id)"
                                          }
                                        ],
                                        class:
                                          "delete-bar " +
                                          (deliverableTemplate.id ==
                                          _vm.stripRemoveDeliverableTemplateId
                                            ? "hovered"
                                            : ""),
                                        attrs: { title: "Delete" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.deleteDeliverableTemplateClick(
                                              deliverableTemplate
                                            )
                                          }
                                        }
                                      },
                                      [_vm._m(2, true)]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            !_vm.isMobile() &&
                            _vm.isSocialMedia(deliverableTemplate)
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "col-md-4 infos publish-status"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex flex-row",
                                        style: _vm.getPublishStatusStyle(
                                          deliverableTemplate.publish_status
                                        )
                                      },
                                      [
                                        _c("PublishStatusListLabel", {
                                          attrs: {
                                            deliverable: deliverableTemplate,
                                            namespace: _vm.namespace
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.isMobile() &&
                            !_vm.isSocialMedia(deliverableTemplate) &&
                            _vm.getSystemSetting("is_chat_enabled") &&
                            deliverableTemplate.total_unread_messages_in_conversation >
                              0
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "col-md-1 infos titles",
                                    on: {
                                      click: function($event) {
                                        return _vm.showModalFn(
                                          deliverableTemplate,
                                          true
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex flex-row" },
                                      [
                                        _c("ListMessageCounter", {
                                          attrs: {
                                            deliverable: deliverableTemplate
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.isMobile() &&
                            !_vm.isSocialMedia(deliverableTemplate)
                              ? _c("div", { staticClass: "col-md-4 infos" }, [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex flex-row" },
                                    [
                                      _vm.showInfoCol(deliverableTemplate) &&
                                      _vm.getSystemSetting(
                                        "media_call__show_owner"
                                      )
                                        ? _c("DeliverableListCoordinators", {
                                            staticClass:
                                              "deliverable-list-coordinators",
                                            attrs: {
                                              deliverable: deliverableTemplate,
                                              namespace: _vm.namespace
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.showInfoCol(deliverableTemplate)
                                        ? _c("DeliverableListContacts", {
                                            staticClass:
                                              "deliverable-list-contacts",
                                            attrs: {
                                              deliverable: deliverableTemplate,
                                              namespace: _vm.namespace
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("DeliverableStatusOverview", {
                                        attrs: {
                                          deliverable: deliverableTemplate,
                                          namespace: _vm.namespace
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-md-12" }, [
                              _c(
                                "div",
                                [
                                  _c(
                                    "b-collapse",
                                    {
                                      attrs: {
                                        visible: _vm.expandAll,
                                        id: "task-listing-collapse-" + index
                                      }
                                    },
                                    [
                                      _vm.isMobile()
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-6 infos responsive-infos"
                                            },
                                            [
                                              _c("div", {
                                                staticClass: "d-flex flex-row"
                                              })
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("TaskFieldLabels", {
                                        attrs: {
                                          fullDeliverables:
                                            _vm.deliverableTemplatesArray,
                                          tasks: deliverableTemplate.tasks,
                                          deliverableId: deliverableTemplate.id,
                                          deliverable: deliverableTemplate,
                                          namespace: _vm.namespace
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("TaskFields", {
                                        attrs: {
                                          fullDeliverables:
                                            _vm.deliverableTemplatesArray,
                                          deliverable: deliverableTemplate,
                                          deliverableId: deliverableTemplate.id,
                                          myWeek: false,
                                          tasks: deliverableTemplate.tasks,
                                          users: deliverableTemplate.users,
                                          namespace: _vm.namespace
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "dbox-right-side dright-inner-wrap" },
                        [
                          _c("CollapseTaskBtn", {
                            attrs: {
                              deliverable: deliverableTemplate,
                              expandAll: _vm.expandAll,
                              index: index,
                              namespace: _vm.namespace
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]
                )
              ]
            )
          : _vm._e()
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-wrapper" },
        [
          _c("pagination", {
            attrs: {
              data: _vm.allDeliverableTemplatesPaginationData,
              limit: _vm.isMobile() ? 3 : 5,
              size: _vm.isMobile() ? "small" : "default"
            },
            on: { "pagination-change-page": _vm.onChangePage }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "data-items hide-mobile" }, [
      _c("span", [_vm._v("POST DATE:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "data-items social-status hide-mobile" }, [
      _c("span", [_vm._v("STATUS")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "fas fa-trash" })])
  }
]
render._withStripped = true

export { render, staticRenderFns }